export const SIGNUP_URL = process.env.NEXT_PUBLIC_APP_URL + '/signup';
export const SIGNIN_URL = process.env.NEXT_PUBLIC_APP_URL + '/signin';
/** Prenotazione demo: l'app apre da sola il modal di prenotazione su /demo */
export const DEMO_URL = process.env.NEXT_PUBLIC_APP_URL + '/demo';
